<div>
  <div class="icon">
    <mat-icon>schedule</mat-icon>
  </div>

  <div class="description">
    <strong [ngSwitch]="activity.meta.action">
      <span *ngSwitchCase="'message'">Message</span>
      <span *ngSwitchCase="'call'">Call Back</span>
      <span *ngSwitchCase="'todo'">To Do</span>
      Reminder Scheduled
    </strong>

    <span>by {{ activity.meta.lenderUserName }} </span>
    <span>for {{ activity.meta.expires * 1000 | date:"EEE MMMM d',' yyyy 'at' h:mma" }} </span>
    <span *ngIf="activity.meta.reason">: "{{ activity.meta.reason }}"</span>
    <span *ngIf="!expired"><a href="javascript:" (click)="cancelReminder()" class="pl-2">Delete</a></span>
  </div>
</div>
